(() => {
  const samePath = (a, b) => {
    try {
      const path = (u) => new URL(u, location.origin).pathname.replace(/\/$/, '');
      return path(a) === path(b);
    } catch {
      return false;
    }
  };

  const openDrawer = (drawer) => {
    const details = drawer.querySelector('details.menu-drawer-container');
    const summary = details?.querySelector(':scope > summary');
    if (!details || !summary) return false;

    if (!details.hasAttribute('open')) summary.click();
    return true;
  };

  const openDetailsOf = (element) => {
    const details = element.closest('details');
    const summary = details?.querySelector(':scope > summary');
    if (!details || !summary) return;

    if (!details.hasAttribute('open')) summary.click();
  };

  const activateTabOf = (element) => {
    const nav = element.closest('[data-mega-menu-tab-id]');
    if (!nav) return;

    const tab = document.querySelector(
      `.mega-menu__tab[data-mega-menu-tab-id="${nav.dataset.megaMenuTabId}"]`
    );
    if (tab && !tab.classList.contains('mega-menu__tab--active')) tab.click();
  };

  const findRow = (drawer, url) => {
    const links = [...drawer.querySelectorAll('.mega-menu__submenu a[href]')].filter(
      (link) => samePath(link.getAttribute('href'), url) && !link.closest('.compact-link')
    );
    return links.find((link) => link.closest('details')?.querySelector('.menu-drawer__submenu')) || links[0];
  };

  const syncHeaderGap = () => {
    const section = document.querySelector('.shopify-section-header');
    const hosts = document.querySelectorAll('.section-shop-by-brand--float');
    if (!section || !hosts.length) return;

    const pill = section.querySelector('.header-wrapper') || section;
    const overhang =
      pill.getBoundingClientRect().bottom - section.getBoundingClientRect().bottom;

    hosts.forEach((host) => {
      host.style.setProperty('--sbb-header-gap', `${Math.max(0, Math.round(overhang))}px`);
    });
  };

  syncHeaderGap();
  window.addEventListener('load', syncHeaderGap);
  window.addEventListener('resize', syncHeaderGap);
  document.addEventListener('shopify:section:load', syncHeaderGap);
  document.fonts?.ready.then(syncHeaderGap);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sbb-drawer]');
    if (!trigger) return;

    if (!customElements.get('header-drawer')) return;

    const drawer = document.querySelector('header-drawer');
    if (!drawer) return;

    const row = findRow(drawer, trigger.getAttribute('href'));
    if (!row || !openDrawer(drawer)) return;

    event.preventDefault();
    activateTabOf(row);

    requestAnimationFrame(() => setTimeout(() => openDetailsOf(row), 50));
  });
})();
